import { useQuery } from 'convex/react';
import type { FunctionReturnType } from 'convex/server';
import { api } from '@aeon-karaoke/cloud-convex';
import { useCurrentUser } from './useCurrentUser';

export type BillboardScope = 'global' | 'friends';
export type Billboard = FunctionReturnType<typeof api.billboard.top>;
export type ChartRow = Billboard['rows'][number];

/** This week's chart for a signed-in reader. Skips until the users row exists
 * (sign-in bootstrap window). */
export function useBillboard(scope: BillboardScope, limit: number) {
  const { user } = useCurrentUser();
  return useQuery(api.billboard.top, user ? { scope, limit } : 'skip');
}

/** The top five for the signed-out column: no identity, no account needed. */
export function usePublicBillboard() {
  return useQuery(api.billboard.publicTop, {});
}
